/**
 * Returns the `data-denali` DOM attribute as a spreadable object, but only
 * outside of production. Production builds drop the attribute entirely so we
 * don't ship the extra markup to real users.
 *
 * Usage:
 *   <div {...setDenaliAttribute('Avatar')} />
 *   <div {...setDenaliAttribute(dataDenali || 'Popover')} />
 */
const setDenaliAttribute = (name: string): { 'data-denali'?: string } =>
  process.env.NEXT_PUBLIC_DEPLOY_NAMESPACE !== 'production' ? { 'data-denali': name } : {};

export default setDenaliAttribute;
